module.exports = __webpack_public_path__ + "static-appopensalud/img/openlegal_white.e8eeebe.png";


//////////////////
// WEBPACK FOOTER
// ./static-appopensalud/img/logos/openlegal_white.png
// module id = 454
// module chunks = 120